import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MediaMarquee from './components/MediaMarquee';
import ServicesSection from './components/ServicesSection';
import PlanesSection from './components/PlanesSection';
import WhyEpicaSection from './components/WhyEpicaSection';
import MetodologiaSection from './components/MetodologiaSection';
import TeamSection from './components/TeamSection';
import ContactSection from './components/ContactSection';
import DiagnosticModal from './components/DiagnosticModal';
import MobileStickyBar from './components/MobileStickyBar';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Footer from './components/Footer';

export default function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<string | undefined>(undefined);

  const handleOpenDiagnostic = (serviceId?: string) => {
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.hash = '#contacto';
    }
  };

  return (
    <div className="min-h-screen w-full max-w-[100vw] overflow-x-hidden bg-[#f8f7f4] text-slate-900 font-sans selection:bg-cyan-500 selection:text-white">
      {/* Header Navigation */}
      <Navbar onOpenDiagnostic={() => handleOpenDiagnostic()} />

      {/* Main Content Sections */}
      <main className="w-full max-w-[100vw] overflow-x-hidden">
        {/* 1. Hero Section */}
        <Hero onOpenDiagnostic={() => handleOpenDiagnostic()} />

        {/* 2. Media Outlets Ticker */}
        <MediaMarquee />

        {/* 3. Core Services Grid (QUÉ HACEMOS) */}
        <ServicesSection onOpenDiagnostic={(serviceId) => handleOpenDiagnostic(serviceId)} />

        {/* 4. Business Plans (PLANES DE NEGOCIO) */}
        <PlanesSection onOpenDiagnostic={(planId) => handleOpenDiagnostic(planId)} />

        {/* 5. Differentiators (POR QUÉ ÉPICA) */}
        <WhyEpicaSection onOpenDiagnostic={() => handleOpenDiagnostic()} />

        {/* 6. Process Steps (METODOLOGÍA) */}
        <MetodologiaSection />

        {/* 7. Team & Leadership (EQUIPO DIRECTIVO) */}
        <TeamSection />

        {/* 9. Strategic Meeting Contact Section */}
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating Quick Action Bar for Mobile Smartphones */}
      <MobileStickyBar onOpenDiagnostic={() => handleOpenDiagnostic()} />

      {/* Floating WhatsApp Button for Desktop PC and Tablets */}
      <FloatingWhatsApp />

      {/* Diagnostic Popup Modal */}
      <DiagnosticModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        preselectedService={selectedService}
      />
    </div>
  );
}
